import React, { useEffect, useState } from 'react';
import { useBreadcrumbs, useUser } from '../hooks';
import { Button, Field, Groupper, Header, Icon, Input, Message, Modal, Table, Toast } from 'react-frontier';
import { bindClick } from '../SiteUtil';
import { SetLoading } from '../SiteClasses';
import UserAccess from '../UserAccess';
import API from '../API';

interface AdjustmentType{
	type_id: number,
	type_name: string,
}

var EmploymentAdjustmentTypes = ()=>{
	var { setTitle } = useBreadcrumbs();
	var { hasAccess } = useUser();
	var canEdit = hasAccess(UserAccess.EMPLOYMENTS.CREATE_PAYOUT);
	var [types, setTypes] = useState<AdjustmentType[]>(null);
	var [loadError, setLoadError] = useState<string>(null);
	var [selectedType, setSelectedType] = useState<AdjustmentType>(null);
	var [typeName, setTypeName] = useState<string>('');
	var [showCreateModal, setShowCreateModal] = useState<boolean>(false);
	var [showEditModal, setShowEditModal] = useState<boolean>(false);
	var [modalPrompts, setModalPrompts] = useState<string[]>(null);

	var load = ()=>{
		API.getEmploymentAdjustmentTypes().then(res=>{
			if(res.error) return setLoadError(res.message);
			setTypes(res.data);
		}).catch(()=> setLoadError('Hubo un error cargando los tipos de ajustes (LCL-1)'));
	};

	useEffect(()=>{
		setTitle('Tipos de ajustes');
		load();
	}, []);

	var onCreate = ()=>{
		setTypeName('');
		setModalPrompts(null);
		setShowCreateModal(true);
	};

	var onEdit = (type: AdjustmentType)=>{
		setSelectedType(type);
		setTypeName(type.type_name);
		setModalPrompts(null);
		setShowEditModal(true);
	};

	var create = (setLoading: SetLoading)=>{
		if(typeName.trim().length < 3) return setModalPrompts(['El nombre debe tener al menos 3 caracteres.']);
		setLoading(true);
		API.createEmploymentAdjustmentType(typeName.trim()).then(res=>{
			if(res.error) return setModalPrompts([res.message]);
			Toast.success('Tipo de ajuste creado!');
			setShowCreateModal(false);
			load();
		}).catch(()=>{
			setModalPrompts(['Hubo un error creando el tipo de ajuste (CRT-1)']);
		}).finally(()=>{
			setLoading(false);
		});
	};

	var edit = (setLoading: SetLoading)=>{
		if(typeName.trim().length < 3) return setModalPrompts(['El nombre debe tener al menos 3 caracteres.']);
		setLoading(true);
		API.editEmploymentAdjustmentType(selectedType.type_id, typeName.trim()).then(res=>{
			if(res.error) return setModalPrompts([res.message]);
			Toast.success('Tipo de ajuste actualizado!');
			setShowEditModal(false);
			load();
		}).catch(()=>{
			setModalPrompts(['Hubo un error editando el tipo de ajuste (EDT-1)']);
		}).finally(()=>{
			setLoading(false);
		});
	};

	if(loadError) return <Header text='Error' subtext={loadError} />
	if(!types) return <Header text='Cargando tipos de ajustes' loading style={{ marginTop: 40 }} centered />

	return <div>
		<Groupper
			width={600}
			style={{ marginTop: 20 }}
			title='Tipos de ajustes'
			titleRight={canEdit && (
				<Button iconName='plus' color='black' text='Agregar' size='small' onClick={onCreate} />
			)}
		>
			<Table
				striped fitted
				className='first last'
				collapsingIndexes={[0, 2]}
				centeredIndexes={[2]}
				headers={['ID', 'Nombre', <Icon name='wrench' />]}
			>
				{types.length !== 0 ? types.map(type=>(
					<Table.Row
						key={type.type_id}
						collapsingIndexes={[0, 2]}
						centeredIndexes={[2]}
						data={[
							type.type_id,
							type.type_name,
							canEdit ? (
								<Button icon basic size='tiny' iconName='pen' onClick={()=> onEdit(type)} />
							) : ''
						]}
					/>
				)) : (
					<Table.Cell row className='empty' colSpan={3}>No hay tipos de ajustes</Table.Cell>
				)}
			</Table>
		</Groupper>
		<Modal open={showCreateModal} onClose={bindClick(setShowCreateModal, false)} size='tiny'>
			<Modal.Header>Agregar tipo de ajuste</Modal.Header>
			<Modal.Content>
				<Field label='Nombre'>
					<Input value={typeName} onChange={setTypeName} placeholder='Ej: INFONAVIT, Bono, Préstamo' />
				</Field>
				<Message type='error' list={modalPrompts} />
			</Modal.Content>
			<Modal.Actions>
				<Button text='Cerrar' basic onClick={bindClick(setShowCreateModal, false)} />
				<Button text='Crear' color='black' onClick={create} />
			</Modal.Actions>
		</Modal>
		<Modal open={showEditModal} onClose={bindClick(setShowEditModal, false)} size='tiny'>
			<Modal.Header>Editar tipo de ajuste</Modal.Header>
			<Modal.Content>
				<Field label='Nombre'>
					<Input value={typeName} onChange={setTypeName} placeholder='Ej: INFONAVIT, Bono, Préstamo' />
				</Field>
				<Message type='error' list={modalPrompts} />
			</Modal.Content>
			<Modal.Actions>
				<Button text='Cerrar' basic onClick={bindClick(setShowEditModal, false)} />
				<Button text='Guardar' color='black' onClick={edit} />
			</Modal.Actions>
		</Modal>
	</div>
}

export default EmploymentAdjustmentTypes;
